import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import About from '../../components/about'
import ProjectSection from '../../components/Projects';
import ServiceSection from '../../components/Services';
import Pricing from '../../components/Pricing'
import FunFact from '../../components/FunFact'
import TeamSection from '../../components/TeamSection';
import Testimonial from '../../components/Testimonial';
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.svg'
import abimg from '../../images/about.jpg'
import { useFetch } from '../../hooks/useFetch';
import { fetchPricing, fetchprojects, fetchServices, fetchTeams, fetchTestimonials } from '../../api/api';
import { useTranslation } from 'react-i18next';


const AboutPage = () => {
    const { t } = useTranslation();

    const {
        data: projects,
        error: projectsError,
        isLoading: projectsIsloading,
    } = useFetch(["projects"], fetchprojects);

    const {
        data: pricingData,
        isLoading: pricingIsLoading,
        error: pricingIsError
    } = useFetch(["pricing"], fetchPricing);
    const {
        data: ServicesData,
        isLoading: ServicesIsLoading,
        error: ServicesIsError
    } = useFetch(["Services"], fetchServices);
    const {
        data: teamsData,
        isLoading: teamsIsLoading,
        error: teamsIsError
    } = useFetch(["teams"], fetchTeams);
    const {
        data: testimonialsData,
        isLoading: testimonialsIsLoading,
        error: testimonialsIsError
    } = useFetch(["testimonials"], fetchTestimonials);
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={t('aboutPage.pageTitle')} pagesub={t('aboutPage.pagesub')} />
            <About abimg={abimg} />
            <ProjectSection projects={projects?.data?.data} projectsIsloading={projectsIsloading} projectsError={projectsError} />
            <ServiceSection services={ServicesData?.data?.data} ServicesIsLoading={ServicesIsLoading} ServicesIsError={ServicesIsError} />
            <FunFact fnClass={'wpo-fun-fact-section-s2'} />
            <Pricing pricingData={pricingData?.data?.pricingData} pricingIsLoading={pricingIsLoading} pricingIsError={pricingIsError} />
            <TeamSection teamsData={teamsData?.data?.data} teamsIsLoading={teamsIsLoading} teamsIsError={teamsIsError} />
            <Testimonial testimonialsData={testimonialsData?.data?.testimonials} testimonialsIsLoading={testimonialsIsLoading} testimonialsIsError={testimonialsIsError} />
            <Footer ftClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutPage;
